import { render } from "./UserUpdatePassword.vue?vue&type=template&id=18886974"
import script from "./UserUpdatePassword.vue?vue&type=script&lang=js"
export * from "./UserUpdatePassword.vue?vue&type=script&lang=js"

import exportComponent from "C:\\frotend\\d7m_front_sindico\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__